import { Component, OnInit } from '@angular/core';

import { FormGroup, Validators, FormControl } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { FuncionalidadeService } from 'src/app/services/funcionalidade.service';
import { Router } from '@angular/router';
import { Security } from 'src/app/utils/security.util';




@Component({
  selector: 'app-funcionalidades',
  templateUrl: './funcionalidades.component.html',
  styleUrls: ['./funcionalidades.component.scss'],
  providers: [FuncionalidadeService]
})
export class FuncionalidadesComponent implements OnInit {

  public cadastrados: any[] = [];
  public form: FormGroup = null;

  public isEditing = false;
  public isProcessing = false;
  public isFiltered = false;
  public isLoading = false;

  public voids: string[] = [];
  public maxRowsVoids = 7;


  constructor(
    private funcionalidadesService: FuncionalidadeService,
    private toastr: ToastrService,
    private modalService: NgbModal,
    private router: Router
  ) { }

  ngOnInit() {

    if (Security.getUser().nivel < 5) {
      this.router.navigate(['/home']);
    }

    this.list(); // carrega lista de já cadastrados
    this.resetForm(); // instancia o formulário utilizado (formGroup)
  }

  public list(): void {
    this.isLoading = true;
    this.funcionalidadesService.list().subscribe((response: any) => {

      this.cadastrados = response;
      this.setVoids();
      this.isLoading = false;
    });
  }

  public resetForm(): void {
    this.form = new FormGroup(
      {
        id: new FormControl(0),
        nome: new FormControl(null, [Validators.required]),
        grupo: new FormControl(null, [Validators.required]),
        rota: new FormControl(null, [Validators.required]),
        ativa: new FormControl(true),
        nivel: new FormControl(1),
        tipo: new FormControl(1),
        descricao: new FormControl(null),
        especifica: new FormControl(null),
        podeAcessar: new FormControl(true),
        podeIncluir: new FormControl(false),
        podeExcluir: new FormControl(false),
        podeAlterar: new FormControl(false),
        podeListar: new FormControl(false),
        estaAutorizado: new FormControl(false),

      }
    );
  }



  public reset(): void {
    this.isEditing = false;
    this.isProcessing = false;
    this.isLoading = false;
    this.resetForm();
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  public read(id: number): void {

    this.reset();
    this.isProcessing = true;

    this.funcionalidadesService.read(id).subscribe(

      (response: any) => {
        this.form.get('id').setValue(response.id);
        this.form.get('nome').setValue(response.nome);
        this.form.get('grupo').setValue(response.grupo);
        this.form.get('rota').setValue(response.rota);
        this.form.get('ativa').setValue(response.ativa);
        this.form.get('nivel').setValue(response.nivel);
        this.form.get('tipo').setValue(response.tipo);
        this.form.get('descricao').setValue(response.descricao);
        this.form.get('especifica').setValue(response.especifica);

        this.form.get('podeAcessar').setValue(response.podeAcessar);
        this.form.get('podeIncluir').setValue(response.podeIncluir);
        this.form.get('podeExcluir').setValue(response.podeExcluir);
        this.form.get('podeAlterar').setValue(response.podeAlterar);
        this.form.get('podeListar').setValue(response.podeListar);
        this.form.get('estaAutorizado').setValue(response.estaAutorizado);


        this.isEditing = true;
        this.isProcessing = false;

      },
      (error: any) => {
        this.showError(error);
      },
    );
  }

  public submit(): void {

    if (this.validForm()) {

      this.isProcessing = true;

      if (this.isEditing === false) {

        this.funcionalidadesService.isUniqueNomeFuncionalidade(this.form.get('nome').value).subscribe(

          (isUniqueNomeFuncionalidade: boolean) => {

            if (isUniqueNomeFuncionalidade) {
              this.save();
            } else {
              this.form.get('nome').setErrors({ isNotUniqueNomeFuncionalidade: true });
              this.isProcessing = false;
            }
          },
          (error: any) => { this.showError(error); }
        );
      } else {
        this.save();
      }
    }

  }

  public validForm() {


    let valid = true;

    if (this.form.get('tipo').value === 2) {
      if (this.form.get('especifica').value == null) {
        this.form.get('especifica').setValidators([Validators.required]);
        this.form.get('especifica').updateValueAndValidity();
        valid = false;
      }
    }


    if (valid === true) {
      if ((this.form.get('tipo').value !== 2)) {
        this.form.get('especifica').setValue(null);
      }

      if (this.form.get('tipo').value === 1) {
        this.form.get('podeAcessar').setValue(true);
      } else {
        this.form.get('podeAcessar').setValue(false);
        this.form.get('estaAutorizado').setValue(true);
      }
    }

    return valid;

  }


  public save() {



    this.funcionalidadesService.create(this.form.value).subscribe(

      (response: any) => {
        this.toastr.success(response.message);
        this.reset();
        this.list();
      },
      (error: any) => {
        this.showError(error);
      }
    );

  }



  public setVoids(): void {
    this.voids = [];
    if (this.cadastrados.length < this.maxRowsVoids) {
      for (let i = this.cadastrados.length; i < this.maxRowsVoids; i++) { this.voids.push(''); }
    }
  }

  public showModalSm(modal: any) {
    this.modalService.open(modal, { windowClass: 'smModal', backdrop: 'static'  });
  }

  public delete(id: number, c: any): void {

    this.isProcessing = true;
    c('Close click');

    this.funcionalidadesService.delete(id).subscribe(

      (response: any) => {
        this.toastr.success(response.message);
        this.reset();
        this.list();
      },
      (error: any) => {
        this.showError(error);
      }
    );
  }

  public showError(error: any) {


    if (error.error.errors) {
      this.toastr.error(error.error.errors[0].message);
    } else {
      this.toastr.error('Ocorreu um erro no servidor');
    }

    this.isProcessing = false;
  }

  public clearValor() {
    this.form.get('valor').setValue(null);
  }

  public setTipoFuncionalidade(tipo: number) {
    this.form.get('tipo').reset();
    this.form.get('tipo').setValue(tipo);

  }

  public setNivelFuncionalidade(nivel: number) {
    this.form.get('nivel').reset();
    this.form.get('nivel').setValue(nivel);

  }

  public setPossivelPermissao(tipoAut: number, value: boolean) {

    switch (tipoAut) {
      case 2:
        this.form.get('podeIncluir').setValue(value);
        break;
      case 3:
        this.form.get('podeAlterar').setValue(value);
        break;
      case 4:
        this.form.get('podeListar').setValue(value);
        break;
      case 5:
        this.form.get('podeExcluir').setValue(value);
        break;

    }

    this.form.get('podeAcessar').setValue(true);

  }


  public ativarDesativar() {

    if (this.isEditing) {

      this.funcionalidadesService.ativarDesativar(this.form.get('id').value).subscribe((data: any) => {

        if (data.mensagem === 'ativado') {
          this.toastr.success(`Funcionaliade ativada com Sucesso`);
        } else {
          this.toastr.success(`Funcionalidade desativada com Sucesso`);
        }

        this.reset();
      },
        (err: any) => {
          this.toastr.error('Não foi possível ativer/desativar Funcionalidade');
        });
    }
  }

}
